var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99999 2.29175C9.06068 2.29175 8.15984 2.66489 7.49565 3.32908C6.83146 3.99327 6.45832 4.89411 6.45832 5.83342V8.54175H13.5417V5.83342C13.5417 4.89411 13.1685 3.99327 12.5043 3.32908C11.8401 2.66489 10.9393 2.29175 9.99999 2.29175ZM14.7917 8.54175V5.83342C14.7917 4.56259 14.2868 3.34381 13.3882 2.44519C12.4896 1.54658 11.2708 1.04175 9.99999 1.04175C8.72916 1.04175 7.51038 1.54658 6.61177 2.44519C5.71315 3.34381 5.20832 4.56259 5.20832 5.83342V8.54175H4.16667C2.90101 8.54175 1.875 9.56776 1.875 10.8334V16.6667C1.875 17.9324 2.90101 18.9584 4.16667 18.9584H15.8333C17.099 18.9584 18.125 17.9324 18.125 16.6667V10.8334C18.125 9.56776 17.099 8.54175 15.8333 8.54175H14.7917ZM4.16667 9.79175C3.59137 9.79175 3.125 10.2581 3.125 10.8334V16.6667C3.125 17.242 3.59137 17.7084 4.16667 17.7084H15.8333C16.4086 17.7084 16.875 17.242 16.875 16.6667V10.8334C16.875 10.2581 16.4086 9.79175 15.8333 9.79175H4.16667Z",
    fill: "#003056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.02e3efec51a8a3b95fec856150a1baad.svg";
export { ForwardRef as ReactComponent };